import React, { Component } from 'react';
import { Input, Modal, Button, Form } from 'antd';

import { Parse } from 'parse';

import {connect} from 'react-redux';
import {FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl} from 'react-intl';

import createHistory from 'history/createBrowserHistory';
import * as actions from '../actions';

import '../styles/Signup.css'

const FormItem = Form.Item;

const messages=defineMessages({
  inputEmail:{
    id:'Reset.input.email',
    defaultMessage:'Enter your e-mail'
  },
  emailRequired:{
    id:'Reset.email.error.required',
    defaultMessage:'Email is required'
  },
  emailType:{
    id:'Reset.email.error.Type',
    defaultMessage:'Email is not a valid email'
  },
});

class Reset extends Component{

  constructor(props) {
    super(props);

    this.state= {
      email: '',
      visible:false,
      loading:false
    };
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
  }

  render() {
    const { getFieldDecorator, getFieldError} = this.props.form;
    const userNameError = getFieldError('email');
    const {formatMessage}=this.props.intl;

      return (
        <div>
            <p className="headline">
              <FormattedMessage
                id={'Reset.headline'}
                defaultMessage={'Reset Password'}
              />
            </p>
            <div className="sign-box">

              <Form onSubmit={this._handleResetPassword}>
                    <FormItem validateStatus={userNameError ? 'error' : ''}>
                      {getFieldDecorator('email', {
                        rules: [
                          {type:'email', message: formatMessage(messages.emailType)},
                          { required: true, message: formatMessage(messages.emailRequired) },
                        ],
                      })(
                        <Input
                        placeholder={formatMessage(messages.inputEmail)}
                        className="sign-input"
                        onChange={this.handleEmailInputChange}/>
                      )}
                    </FormItem>

                    <FormItem>
                      <button className="sign-button" type="primary" htmltype="submit">
                        <FormattedMessage
                          id={'Reset.btn'}
                          defaultMessage={'Send'}
                        />
                      </button>
                    </FormItem>
                  </Form>

            </div>

            <Modal
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              footer={[
                <Button key="submit"
                  type="primary"
                  size="large"
                  style={{backgroundColor:'#5fffaf',border:'none',width:'85px'}}
                  loading={this.state.loading}
                  onClick={this.handleOk}
                  >
                  <FormattedMessage
                    id={'Reset.modal.btn'}
                    defaultMessage={'OK'}
                  />
                </Button>,
                ]}
              className="reset-modal">
              <p className="reset-title">
                <FormattedMessage
                  id={'Reset.modal.title'}
                  defaultMessage={'Check your E-mail'}
                />
              </p>
              <span className="reset-explan-underline">
                <FormattedHTMLMessage
                  id={'Reset.modal.explain.underline'}
                  defaultMessage={'Didn&#39;t receive the E-mail?'}
                />
              </span>&#x1F914;&#x1F914;&#x1F914;
              <p className="reset-explan">
                <FormattedMessage
                  id={'Reset.modal.explain'}
                  defaultMessage={'Please check your E-mail address or spam.'}
                />
              </p>
            </Modal>

        </div>
      )
    }

    handleCancel = () => {
       this.setState({ visible: false });
     }

    handleOk = (e) => {
        console.log(e);
        this.setState({
          visible: false,
        });
        const history = createHistory();
        history.push('/login');
        history.go();
      }

    handleEmailInputChange(e) {
      this.setState({
        email: e.target.value
      })
    }

    _handleResetPassword= (event) => {
      const {email}=this.state;

      event.preventDefault();
      this.props.form.validateFields((err, values) => {//값이 비어있는지 검증 위해
        if (!err) {
          Parse.User.requestPasswordReset(email)
          .then(
            ()=>{
              console.log('success');
            //성공했을 시 모달창 보이게
            this.setState({
              visible: true,
            });
            this.props.resetSuccess();
          })
          .catch(
            (error)=>{
              console.log(error);
              alert(error.message);
              this.props.resetFailed(error);
            });

          }
        });


    }


}//end Reset class
  
Reset=Form.create({})(injectIntl(Reset));

// export default Reset;
const mapStateToProps = (state)=>{
  return{

    ...state.sessionReducer
  };
};

const mapDispatchToProps=(dispatch)=>{
  return{
    resetSuccess:()=>{dispatch(actions.resetSuccess())},
    resetFailed:(error)=>{dispatch(actions.resetFailed(error))}
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reset);
